<template>
  <div class="home mx-auto">
    <cabecera-web></cabecera-web>
    

    <ver-establecimientos></ver-establecimientos>
   
  </div>
</template>

<script>
// @ is an alias to /src
import VerEstablecimientos from '@/components/TestoSearch.vue'
import CabeceraWeb from "@/components/Cabecera"

export default {
  name: 'Home',
  components: {
    VerEstablecimientos,
    CabeceraWeb
  }
}
</script>